// src/hooks/useAuth.js
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import { ROUTES } from "../constants";
import apiService from "../services/api.service";

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth debe ser usado dentro de AuthProvider");
  }

  const logout = async (redirectTo = ROUTES.LOGIN) => {
    try {
      // Guardamos la ruta deseada en sessionStorage para que el efecto global lo lea
      try {
        sessionStorage.setItem("postLogoutRedirect", redirectTo);
      } catch (e) {
        // si falla sessionStorage no es crítico
        console.warn("No se pudo setear postLogoutRedirect:", e);
      }

      await signOut(auth);
      apiService.clearTokenCache();

      // NO hacemos navigate() aquí: lo maneja el efecto central (Sidebar)
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      throw error;
    }
  };

  const isCiudadano = context.userData?.role === "ciudadano";
  const isAdmin = context.userData?.role === "admin";
  const isAgenteMunicipal = context.userData?.role === "agente_municipal";
  const hasAdminAccess = isAdmin || isAgenteMunicipal;

  return {
    ...context,
    logout,
    isAdmin,
    isCiudadano,
    isAgenteMunicipal,
    hasAdminAccess
  };
};